import { getAssetUrl } from '@lighthouse/assets'
import { NoFound, useAtomAction, useAtomData } from '@lighthouse/shared'
import React, { useCallback, useEffect } from 'react'

import { createPageAtom, initPageStackAtom, openPageStackAtom } from '@/atoms/page/action'
import { lastPageTypeOfStackAtom, pageStackAtom } from '@/atoms/page/state'
import { stackFactory } from '@/atoms/page/utils'
import { Page as PageContainer } from '@/containers/page'
import { useLanguage } from '@/hooks/useApplication'
import { useCurrentLanguagePageList } from '@/hooks/usePage'

const Page: React.FC = () => {
    const pageList = useCurrentLanguagePageList()
    const lastPageTypeOfStack = useAtomData(lastPageTypeOfStackAtom)
    const language = useLanguage()
    const { run: setPageStack } = useAtomAction(pageStackAtom)
    const { run: openPageStack } = useAtomAction(openPageStackAtom)
    const { run: initPageStack } = useAtomAction(initPageStackAtom)

    const { pageId, stackId } = lastPageTypeOfStack || {}

    // 如果是初次进入，设置初始页面栈
    useEffect(() => {
        if (!pageId) {
            initPageStack()
        }
    }, [initPageStack, pageId])

    useEffect(() => {
        return () => {
            setPageStack(null)
        }
    }, [setPageStack])

    const { run: createPage } = useAtomAction(createPageAtom)

    const handlePageAdd = useCallback(async () => {
        const pageId = await createPage({ name: '新的页面', lang: language, type: 'COMMON' })
        openPageStack(stackFactory({ pageId }))
    }, [createPage, language, openPageStack])

    if (pageList.length === 0) {
        return (
            <NoFound
                image={getAssetUrl('empty', 'no_page.svg')}
                title="找不到页面"
                desc="没有页面"
                btnText="创建页面"
                onBtnClick={handlePageAdd}
            />
        )
    }

    if (!pageId || !stackId) {
        return null
    }

    return <PageContainer pageId={pageId} stackId={stackId} />
}

export default Page
